import { render, staticRenderFns } from "./sms_fields.vue?vue&type=template&id=746660e0&"
import script from "./sms_fields.vue?vue&type=script&lang=js&"
export * from "./sms_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports